import React, { lazy } from 'react';

const TaxSchemeListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/TaxSchemeModule/TaxSchemeListing'
  ).then(module => ({
    default: module.TaxSchemeListing,
  })),
);

const TaxSchemeForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/TaxSchemeModule/TaxSchemeForm'
  ).then(module => ({
    default: module.TaxSchemeForm,
  })),
);

const taxSchemeRoutes = [
  {
    props: { exact: true, path: '/common-settings/tax-scheme/' },
    component: <TaxSchemeListing software="Contract" />,
  },
  {
    props: { exact: true, path: '/common-settings/tax-scheme/add' },
    component: <TaxSchemeForm software="Contract" mode="add" />,
  },
];

export default taxSchemeRoutes;
